import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {InspectionOutcomeBadgeVariant, resolveInspectionOutcomeBadge,} from '../../../services/vte/vte.constants';

@Component({
    selector: 'app-inspection-outcome-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span *ngIf="badge as resolved" class="inspection-outcome-badge" [ngClass]="resolved.variant">
            {{ resolved.label }}
        </span>
    `,
    styles: [`
        .inspection-outcome-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            line-height: 1.2;
            white-space: nowrap;
        }

        .inspection-outcome-badge.pass { background: #DCFCE7; color: #16A34A; }
        .inspection-outcome-badge.fail { background: #FEE2E2; color: #DC2626; }
        .inspection-outcome-badge.warning { background: #FEF3C7; color: #D97706; }
        .inspection-outcome-badge.manual_review { background: #FFEDD5; color: #EA580C; }
        .inspection-outcome-badge.neutral { background: #E5E7EB; color: #374151; }
    `],
})
export class InspectionOutcomeBadgeComponent {
    @Input() outcome: string | null | undefined = '';

    get badge(): { label: string; variant: InspectionOutcomeBadgeVariant } | null {
        return resolveInspectionOutcomeBadge(this.outcome);
    }
}
